import { useTranslation } from "react-i18next";
import { colors, css, fonts, glyphs, useMediaQuery } from "../../../Styles";
import { CheckBox, CheckStyles, NewButton } from "../..";
import {Location} from "../../../Services/Agrisys_GqlDataCaller/"
import { Station } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations";
import { SystemTypes } from "../../../Definitions";

interface SystemControlsInner_Props {
  systemType?: SystemTypes;
  focus_view?: boolean;
  activeListType?: "Card" | "List";
  selectContent: JSX.Element
  locationVisual: JSX.Element;
  activeLocationsList: JSX.Element;
  activeLocationsListHeader: String;
  selectLocation: {
    selectedLocations: Location[] | Station[]; 
    isAllSelected: boolean
    handleSelectAll: () => void;
  }
  error: {
    errorText: string
    elementId: number
  }
  button?: {
    onClick: () => void;
    content: string;
    startEnhancer: keyof typeof glyphs;
    disabled: boolean
  }
}

export default function SystemControlsInner({ systemType, focus_view, activeListType="List", selectContent, button, locationVisual, activeLocationsList, activeLocationsListHeader, selectLocation, error }: SystemControlsInner_Props) {
  const { t } = useTranslation();
  const mobile = useMediaQuery(`(max-width: 720px)`) || focus_view === true;

  const stations = systemType !== SystemTypes.freedaLf ? true : false

  const _fontSize = { ...(focus_view ? fonts.fontSize3 : fonts.fontSize4) }

  const card = activeListType === "Card"
       
  return (
    <div style={{ minHeight: mobile ? "100%" : undefined, height: mobile ? undefined : "100%", boxSizing: "border-box", gap: mobile ? "20px 0px" : "20px", display: "grid", gridTemplateColumns: mobile ? "1fr" : card ? "fit-content(100%) 2px 280px" : "280px 2px 280px", gridTemplateRows: mobile ? "fit-content(100%) 2px fit-content(100%)" : "100%" }}>

      {/* Controls */}
      <div style={{ gridArea: "1/1/2/2", height: "100%", display: "grid", gap: "10px", gridTemplateColumns: "100%", gridTemplateRows: mobile ? `${button && "60px"} fit-content(100%) 250px 17px` : `${button && "50px"} fit-content(100%) 1fr 17px` }}>
        
        {/* Start Selected */}
        {button && <div style={{ gridArea: "1/1/2/2", boxSizing: "border-box", width: "100%", display: "flex", justifyContent: "center" }}>
          <NewButton
            focus_view={focus_view}
            content={button.content}
            startEnhancer={glyphs[button.startEnhancer]({ size: focus_view ? "40px" : "35px" })}
            overrides={{
              baseStyles: { backgroundColor: colors.greySecondary, width: "280px" },
              hoverStyles: { backgroundColor: colors.greyDarkSecondary },
            }}
            onClick={button.onClick}
            disabled={button.disabled}
          />
        </div>}

        {/* SelectContent */}
        <div style={{ gridArea: "2/1/3/2", display: "flex", justifyContent: "center" }}>
          {selectContent}
        </div>

        {/* Active Pen List */}
        <div style={{ gridArea: "3/1/4/2", height: "100%", overflow: "hidden", boxSizing: "border-box", display: "flex", flexDirection: "column"}}>
          <p style={{ ...fonts.header, ..._fontSize, color: colors.greyDarkPrimary, width: "60px", padding: "0px 0px 2px 10px" }}>
            {activeLocationsListHeader}:
            {/* {`${t("systemControls.general.feeding", { defaultValue: "feeding" })}:`} */}
          </p>

          <div style={{
            position: "relative",
            backgroundColor: card ? colors.greyLightTertiary : colors.greyLightSecondary,
            borderRadius: card ? undefined : "10px",
            padding: card ? "5px 0px" : "5px 10px",
            height: "100%",
            overflow: "hidden",
            borderWidth: card ? "2px 0px 2px 0px" : undefined,
            borderColor: card ? colors.greyLightSecondary : undefined,
            borderStyle: card ? "solid" : undefined
          }}>
            {((selectLocation&&selectLocation.selectedLocations) === undefined || (selectLocation&&selectLocation.selectedLocations?.length) === 0) && 
              <p style={{ ..._fontSize, ...css.emptyPen, opacity: "0.5", padding: card ? "0px" : "0px" }}>{`${stations ? t("systemControls.general.noStationsSelected", { defaultValue: "No stations selected" }) : t("systemControls.general.noPensSelected", { defaultValue: "No pens selected" })}!`} </p>
            }
            {(selectLocation&&selectLocation.selectedLocations) &&
              <div style={{ height: "100%", overflowY: "auto", scrollbarColor: colors.greyTertiary + colors.transparent, scrollbarWidth: "thin", gap: card ? "10px" : "0px", display: "flex", flexDirection: "column" }}>
                {activeLocationsList}
              </div>
            }

          </div>
        </div>

        {/* Message */}
        <div style={{ gridArea: "4/1/5/2", textAlign: "center", opacity: error ? "1" : "0", color: error&&error.elementId === 2 ? colors.systemGreen : colors.systemRed, ...fonts.header, transition: "opacity 0.3s ease-in-out", ..._fontSize }}>{error&&error.errorText}</div>

      </div>

      {/* Seperator */}
      <div style={{ gridArea: mobile ? "2/1/3/2" : "1/2/2/3", borderLeft: mobile ? undefined : "2px solid " + colors.greyTertiary, borderBottom: mobile ? "2px solid " + colors.greyTertiary : undefined }} />

      {/* Pens */}
      <div style={{ gridArea: mobile ? "3/1/4/3" : "1/3/2/4", height: "100%", width: "100%", display: "grid", gap: "5px", gridTemplateRows: mobile ? "30px 2px 250px 2px 30px" : "22px 2px 1fr 2px 22px", gridTemplateColumns: "100%" }}>

        {/* Select Text */}
        <p style={{ gridArea: "1/1/2/2", ...fonts.paragraph, ..._fontSize, color: colors.greyDarkPrimary, textAlign: "center" }}> {`${stations ? t("systemControls.general.clickStation", { defaultValue: "Click every station you want to select" }) : t("systemControls.general.clickPen", { defaultValue: "Click every pen you want to select" })}:`} </p>

        {/* Seperator */}
        <div style={{ gridArea: "2/1/3/2", borderBottom: "2px solid " + colors.greyLightSecondary, width: mobile ? "80%" : undefined, margin: mobile ? "0 auto" : undefined }} />
        
        {/* Section */}
        <div style={{
          gridArea: "3/1/4/2",
          transition: "filter 0.3s ease-in-out",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarColor: colors.greyTertiary + colors.transparent,
          scrollbarWidth: "thin",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start"
        }}>
          <div style={{display: "block", margin: "auto"}}>
            {locationVisual}
          </div>
        </div>

        {/* Seperator */}
        <div style={{ gridArea: "4/1/5/2", borderBottom: "2px solid " + colors.greyLightSecondary, width: mobile ? "80%" : undefined, margin: mobile ? "0 auto" : undefined }} />

        {/* Select All */}
        <div style={{ gridArea: "5/1/6/2", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "5px"}}>
          <p style={{ ...fonts.paragraph, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4),  color: colors.greyDarkPrimary }}> {`${t("systemControls.general.orSelectAll", { defaultValue: "Or select all" })}:`} </p>
          <CheckBox
            focus_view={focus_view}
            checkStyle={CheckStyles.grey}
            onChange={selectLocation&&selectLocation.handleSelectAll}
            isChecked={selectLocation&&selectLocation.isAllSelected}
          />
        </div>

      </div>

    </div>
  )
}